import { render, staticRenderFns } from "./Appbar.vue?vue&type=template&id=b0b96bf4"
import script from "./Appbar.vue?vue&type=script&lang=js"
export * from "./Appbar.vue?vue&type=script&lang=js"
import style0 from "./Appbar.vue?vue&type=style&index=0&id=b0b96bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports